import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { kpCertificaat } from '../dto/kp-certificaat';
import { CrudService } from '@mango/core';

@Injectable({ providedIn: 'root' })
export class kpCertificaatService extends CrudService<kpCertificaat> {

    constructor(injector: Injector) { super(kpCertificaat, injector); }

}
